<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <ng-template #licenseContent let-modal>
                        <div class="modal-header">
                          <h4 class="modal-title" id="modal-basic-title">
                            {{ mode === 'add' ? 'Add License' : 'Edit License' }}
                          </h4>
                          <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
                        </div>
                        <div class="modal-body">
                          <form class="theme-form" [formGroup]="licenceUserForm">
                            <div class="form-group">
                              <div style="" ><img class="img-60" [src]="previewLogo || 'assets/images/user/1.jpg'" alt="#">
                                <div class="profile-edit"><a>
                                  <i class="icofont icofont-pencil-alt-5"><input class="upload" type="file" (change)="readUrl($event)" /></i>
                                </a></div>
                              </div>
                              <div class="row mt-2">

                                <!-- Company Name -->
                                <div class="col-xl-6">
                                  <label class="col-form-label">Company Name</label>
                                  <input class="form-control" type="text" placeholder="Enter company name" formControlName="companyName" />
                                  <div *ngIf="licenceUserForm.controls['companyName'].touched && licenceUserForm.controls['companyName'].errors?.['required']" class="text text-danger mt-1">
                                    Company Name Required
                                  </div>
                                </div>
                                <div class="col-xl-6">
                                    <label class="col-form-label">Company Code</label>
                                    <input class="form-control" type="text" placeholder="Enter company name" formControlName="companyCode" />
                                    <div *ngIf="licenceUserForm.controls['companyCode'].touched && licenceUserForm.controls['companyCode'].errors?.['required']" class="text text-danger mt-1">
                                      Company Code Name Required
                                    </div>
                                  </div>
                        
                                <!-- Admin Email -->
                                <div class="col-xl-6">
                                  <label class="col-form-label">Admin Email</label>
                                  <input class="form-control" type="email" placeholder="Enter admin email" formControlName="companyEmail" />
                                  <div *ngIf="licenceUserForm.controls['companyEmail'].touched && licenceUserForm.controls['companyEmail'].errors?.['required']" class="text text-danger mt-1">
                                    Email Required
                                  </div>
                                </div>
                      
                                <div class="col-xl-6">
                                  <label class="col-form-label">License Type</label>
                                  <select class="form-select" formControlName="licenseType">
                                    <option [value]="licenceType.Demo">Demo</option>
                                    <option [value]="licenceType.Standard">Standard</option>
                                    <option [value]="licenceType.Enterprise">Enterprise</option>
                                  </select>
                                  <div *ngIf="licenceUserForm.controls['licenseType'].touched && licenceUserForm.controls['licenseType'].errors?.['required']" class="text text-danger mt-1">
                                    License Type Required
                                  </div>
                                </div>


                                <div class="col-xl-6">
                                  <label class="col-form-label">Start Date</label>
                                  <input class="form-control" type="date" formControlName="startDate" />
                                  <div *ngIf="licenceUserForm.controls['startDate'].touched && licenceUserForm.controls['startDate'].errors?.['required']" class="text text-danger mt-1">
                                    Start Date Required
                                  </div>
                                </div>

                                <!-- End Date -->
                                <div class="col-xl-6">
                                  <label class="col-form-label">End Date</label>
                                  <input class="form-control" type="date" formControlName="endDate" />
                                  <div *ngIf="licenceUserForm.controls['endDate'].touched && licenceUserForm.controls['endDate'].errors?.['required']" class="text text-danger mt-1">
                                    End Date Required
                                  </div>
                                </div>

                                <!-- Number of Users Slider -->
                                <div class="col-xl-6">
                                  <label class="col-form-label">Number of Users</label>
                                  <input type="range" class="form-range" min="1" max="500" formControlName="noOfUsers" (input)="onSliderChange($event)" />
                                  <div>{{ licenceUserForm.controls['noOfUsers'].value }}</div>
                                </div>
                      
                                <!-- Is Active -->
                                <div class="col-xl-6 d-flex align-items-center">
                                  <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" formControlName="isActive" id="flexSwitchCheckChecked" />
                                    <label class="form-check-label" for="flexSwitchCheckChecked">Active</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                      
                            <div class="modal-footer">
                              <button class="btn btn-outline-warning" (click)="cancelForm(modal)">
                                <i class="fa fa-times"></i> Cancel
                              </button>
                              <button type="submit" (click)="onSubmit()" class="btn btn-outline-primary">
                                <i class="fa fa-check"></i> {{ mode === 'add' ? 'Save' : 'Update' }}
                              </button>
                            </div>
                          </form>
                        </div>
                      </ng-template>
                      <ng-template #initializeDBModal let-modal>
                        <div class="modal-header">
                          <h4 class="modal-title" id="modal-basic-title">
                           SQL Server Connection
                          </h4>
                          <button type="button" class="btn-close" aria-label="Close" (click)="cancelInitializeDbForm(modal)"></button>
                        </div>
                        <div *ngIf="dbInitializePOV == 1">
                          <div class="modal-body">
                            <form class="theme-form" [formGroup]="initializeDbForm">
                              <div class="form-group">
                                <div class="row">
                                  <div class="col-xl-3">
                                    <label class="col-form-label">{{ 'Sql Server Instance:' | translate }}</label>

                                  </div>
                                  <!-- Instances Dropdown -->
                                  <div class="col-xl-6">
                                    <mat-select formControlName="server" id="employeeId" class="custom-mat-select">
                                      <mat-option [value]="0" disabled>{{ 'Select Instance' | translate }}</mat-option>
                                      <!-- <mat-option *ngIf="loadingInstance" disabled>{{ 'Getting Instances...' }}</mat-option> -->
                                      <!-- <mat-option *ngIf="!loadingInstance && sqlInstances.length === 0" disabled>{{ 'No instances available' }}</mat-option> -->
                                      <!-- <mat-option [value]="'DESKTOP-APBIKC7'">DESKTOP-APBIKC7</mat-option> -->
                                      <mat-option *ngFor="let instance of sqlInstances" [value]="instance"> 
                                        {{ instance }}
                                      </mat-option>
                                    </mat-select>
                                    <div *ngIf="initializeDbForm.get('server')?.touched && initializeDbForm.get('server')?.invalid" class="text-danger">
                                      <div *ngIf="initializeDbForm.get('server')?.errors?.['required']">{{ 'Server is required' }}</div>
                                    </div>
                                  </div>
                                  <div class="col-xl-3"><button (click)="getSqlInstances()" class="btn btn-primary">Search</button></div>

                                  </div>
                                  <div class="row">
                                  </div>
                                  <br>
                                  <div class="row">
                                    
                                    <div class="col-xl-3">
                                      <label class="col-form-label">{{ 'Username:' | translate }}</label>
  
                                    </div>
                                  <!-- Username -->
                                  <div class="col-xl-6">
                                    <input (click)="onUsernamePasswordClick('username')" class="form-control" type="text" placeholder="Enter username" formControlName="username" />
                                    <div *ngIf="initializeDbForm.controls['username'].touched && initializeDbForm.controls['username'].errors?.['required']" class="text text-danger mt-1">
                                      Username Required
                                    </div>
                                  </div>
                                  </div>
                                  <br>
                                  <div class="row">
                                    <div class="col-xl-3"><label>Password</label></div>
                                  <!-- Password -->
                                  <div class="col-xl-6">
                                      
                                      <input (click)="onUsernamePasswordClick('password')"  class="form-control" type="text" placeholder="Enter company name" formControlName="password" />
                                      <div *ngIf="initializeDbForm.controls['password'].touched && initializeDbForm.controls['password'].errors?.['required']" class="text text-danger mt-1">
                                        Password Required
                                      </div>
                                    </div>

                                    </div>
                                    <br>
                                    <div class="row">
                                      <div class="col-xl-8"></div>
                                      <div class="col-xl-4">
                                        <button type="button" (click)="testConnection()" class="btn btn-outline-primary">
                                          <i class="fa fa-check"></i> Test Connection
                                        </button>
                                      </div>
                                    </div>
                                    
                                    <br>
                                    <div class="row">
                                      
                                    <div >
                                      
                                      <div class="row" (click)="onDatabaseNameClick()">
                                        <div class="col-xl-3" ><label class="">Database Name</label></div>
                                        <div class="col-xl-6">
                                          
                                          <input class="form-control" (click)="onDatabaseNameClick()"  type="text" placeholder="Enter database name" formControlName="databaseName" >
                                          <div *ngIf="initializeDbForm.controls['databaseName'].touched && initializeDbForm.controls['databaseName'].errors?.['required']" class="text text-danger mt-1">
                                            Database Name is required
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  
                              </div>
                        
                              
                              </div>
                            </form>
                          </div>
                          <!-- modal body end -->
                          <div class="modal-footer">
                            <button class="btn btn-outline-warning" (click)="cancelInitializeDbForm(modal)">
                              <i class="fa fa-times"></i> Cancel
                            </button>
                            
                            <button *ngIf="testConnectionSuccess" type="button" (click)="createDatabase()" class="btn btn-outline-success">
                              <i class="fa fa-database"></i> Create Database
                            </button>
                          </div>
                        </div>
                        <div *ngIf="dbInitializePOV == 2">
                          <div class="modal-body">
                            execute script
                          </div>
                          <!-- modal body end -->
                          <div class="modal-footer">
                            
                            <button type="button" (click)="BackToOne()" class="btn btn-outline-success">
                              <i class="fa fa-arrow-left"></i> Back
                            </button>
                            <button *ngIf="testConnectionSuccess" type="button" (click)="executeScript()" class="btn btn-outline-success">
                              <i class="fa fa-play"></i> Execute Script
                            </button>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template #deleteLicenseContent let-modal>
                        <div class="modal-header">
                            <h4 class="modal-title" id="modal-basic-title">Delete Confirmation</h4>
                            <button type="button" class="btn-close" aria-label="Close"
                                (click)="modal.dismiss('Cross click')"></button>
                        </div>
                        <div class="modal-body">
                            <form class="theme-form" [formGroup]="licenceUserForm">
                                <div class="form-group">
                                    <p>Are you sure you want to delete this?</p>
                                    
                                    
                                </div>
                               
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')"><i
                                class="fa fa-times"></i>
                            Cancel</button>
                            <button class="btn btn-outline-danger" (click)="modal.close('Delete')"><i
                                class="fa fa-trash-o"></i>
                            Delete</button>
                           
                                    
                                    
                            
                        </div>
                    </ng-template>
                    
                    <div class="row justify-content-end margin-top-bottom-for-add">
                        <div class="col-auto">
                            <button (click)="openModalForAdd(licenseContent)" class="btn btn-outline-primary" style="margin: 3px;"
                                ><i class="fa fa-plus"></i> {{'ADD' | translate }}</button>
                            <!-- 
                <button class="btn btn-outline-danger" style="margin: 3px;"
                    (click)="openDeleteModal(deleteDepartmentContent)">Delete</button> -->
                        </div>
                    </div>
                    <br />
                    <div class="custom-datatable noscroll">
                        <div class="custom-datatable">
                            <table datatable  [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"  class="table" id="table1">
                                <thead>
                                  <tr>
                                    <th scope="col">{{ 'COMPANY_CODE' | translate }}</th>
                                    <th scope="col">{{ 'COMPANY_NAME' | translate }}</th>
                                    <th scope="col">{{ 'EMAIL' | translate }}</th>
                                    <th scope="col">{{ 'STATUS' | translate }}</th>
                                    <th scope="col">{{ 'Licence Type' | translate }}</th>
                                    <th scope="col">{{ 'ACTIONS' | translate }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let user of licenceUsers">
                                    <td>{{ user.companyCode }}</td>
                                    <td>{{ user.companyName }}</td>
                                    <td>{{ user.companyEmail }}</td>
                                    
                                    <td title="{{ user.isActive ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}">
                                      <span class="badge" [ngClass]="user.isActive ? 'badge-success' : 'badge-danger'">
                                        {{ user.isActive ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}
                                      </span>
                                    </td>
                                    <td>{{ getLicenceType(user.licenseType) }}</td>
                                    <td>
                                      <div class="row">
                                        <div class="col-sm-6">
                                          <div ngbDropdown class="d-inline-block" placement="bottom">
                                            <button style="background-color: #4466f2;font-size: 12px !important;" class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle >Action</button>
                                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" >
                                              <button class="dropdown-item" (click)="openModalForEdit(user, licenseContent)">{{ 'EDIT' | translate }}</button>
                                              <button class="dropdown-item" (click)="deleteLicenceUser(deleteLicenseContent, user)">{{ 'DELETE' | translate }}</button>
                                            </div>
                                          </div>
                                        </div>
                                        
                                      </div>
                                      <div class="row mt-1">
                                        <!-- <div class="col-sm-12">
                                          <button class="btn btn-primary btn-sm" (click)="openDbInitializeModal(user, initializeDBModal)" style="font-size: 12px !important;margin-top: 1%;">{{ 'INITIALIZE_DATABASE' | translate }}</button>    

                                        </div> -->
                                      </div>
                                      <!-- Dropdown Container -->
                        
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              
                            <div class="d-flex justify-content-between p-2">

                            </div>
                        </div>
                    </div>




                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->